var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-editor emoji-editor",style:(_vm.blockStyle),attrs:{"id":_vm.blockId}},[_c('svg',{class:_vm.animateClass,attrs:{"width":"100%","viewBox":_vm.viewBox}},[_c('text',{attrs:{"x":_vm.xCoord,"y":_vm.yCoord}},[_vm._v(_vm._s(_vm.emoji.native))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }